<mat-card>
  <mat-card-content>
  <mat-form-field>
      <mat-label>Product</mat-label>
      <mat-select [(value)]="selectedProduct" (selectionChange)="productChange($event)">
      <mat-option *ngFor="let product of products" [value]="product">
          <div fxLayout="row" fxLayoutAlign="start center">
          <div class="m-r-10 chart-select-color" [style.background-color]="product.productColor"></div><div>{{product.product}}</div>
          </div>
      </mat-option>
      </mat-select>
  </mat-form-field>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-content>
    <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
      <label>Cached</label>
      <button mat-flat-button color="accent" (click)="onClickExport()" [disabled]="dataSource?.data?.length === 0">
        <mat-icon>download</mat-icon> Download CSV
      </button>
    </div>

    <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
      <mat-card-content>
        <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
          <mat-form-field class="accent">
            <mat-label>Search cache</mat-label>
            <input matInput type="text" [(ngModel)]="searchTerm" (keyup.enter)="loadRenderedOutputs()"
              (keyup.esc)="searchTerm=''; loadRenderedOutputs()" name="searchTerm" placeholder="Search Name">
            <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear"
              (click)="searchTerm=''; loadRenderedOutputs()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div fxLayout="row" fxLayoutGap="10px">
            <button type="submit" mat-flat-button color="primary" (click)="loadRenderedOutputs()" matTooltip="Search"
              [class.button-spinner]="loading" [disabled]="loading">
              <mat-icon>search</mat-icon> Search
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="contrast" *ngFor="let item of dataSource.data" [class.banner-error]="item?.disabled" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="85" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="2px">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
            <strong class="text-center" [matTooltip]="item?.id" [ngClass.lt-sm]="{'card-title': true}" [ngStyle]="{ 'color': getProductColour(item?.productName) }">
              {{ productName[item?.productName] }} 
            </strong>
            <mat-icon *ngIf="item?.isProduction" color="accent">verified</mat-icon>
          </div>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center" fxLayoutGap="2px">
            <div class="m-l-10" *ngIf="item?.homeConfig?.home" fxLayoutGap="5px">
              <span class="text-small">home</span>
              <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'home: ' + item.homeConfig.home" [innerHtml]="item.homeConfig.home | encodeHtml | highlight: searchTerm"></span>
            </div>
            <div *ngIf="item?.homeConfig?.masterFile" fxLayoutGap="5px">
              <span class="text-small">master</span>
              <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'masterFile: ' + item.homeConfig.masterFile" [innerHtml]="item.homeConfig.masterFile | encodeHtml | highlight: searchTerm"></span>
            </div>
            <div *ngIf="item?.homeConfig?.options?.length > 0" fxLayoutGap="5px">
              <span class="text-small">options</span>
              <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'options: ' + (item.homeConfig.options.join(', '))" [innerHtml]="item.homeConfig.options.join(', ') | encodeHtml | highlight: searchTerm"></span>
            </div>
            <div *ngIf="item?.styleConfigTemplate?.name" fxLayoutGap="5px">
              <span class="text-small">template</span>
              <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'style template: ' + item?.styleConfigTemplate?.name" [innerHtml]="item.styleConfigTemplate.name | encodeHtml | highlight: searchTerm"></span>
            </div>
          </div>
        </div>
        <div fxFlex="15" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="5px">
          <a *ngIf="(item.productName === productName.Panorama || item.productName === productName.RayTracedDraft || item.productName === productName.RayTraced || item.productName === productName.RayTracedPlus)"
            [disabled]="item.status !== status.Complete"
            matSuffix mat-icon-button color="accent" matTooltip="View"
            target="_blank" [routerLink]="['/situ-view']" [queryParams]="{ id: item.id }">
            <mat-icon>vrpano</mat-icon>
          </a>

          <a *ngIf="(item.productName === productName.Insights)"
            [disabled]="item.status !== status.Complete"
            matSuffix mat-icon-button color="accent" matTooltip="View Insights"
            target="_blank" [routerLink]="['/situ-view']" [queryParams]="{ id: item.id }">
            <mat-icon>insights</mat-icon>
          </a>

          <a *ngIf="(item.productName === productName.Plan)"
            [disabled]="item.status !== status.Complete"
            matSuffix mat-icon-button color="accent" matTooltip="View Plan"
            target="_blank" [routerLink]="['/situ-view']" [queryParams]="{ id: item.id }">
            <mat-icon>schema</mat-icon>
          </a>

          <a *ngIf="(item.productName === productName.Facade)"
            [disabled]="item.status !== status.Complete"
            matSuffix mat-icon-button color="accent" matTooltip="View Facade"
            target="_blank" [routerLink]="['/situ-facade']" [queryParams]="{ id: item.id }">
            <mat-icon>image</mat-icon>
          </a>

          <source-artifacts-menu [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [sourceArtifacts]="item.sourceArtifacts"></source-artifacts-menu>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
      <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
        [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
        (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card>
  </mat-card-content>
</mat-card>
